module.exports = __webpack_public_path__ + "img/logo.60c6a17b.png";